import ProductDetailLine from "@core-components/product-detail-line/ProductDetailLine";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group } from "@mantine/core";
import { IconBolt } from "@tabler/icons-react";

interface IProps {
  advantages?: string[];
}

const SkinAdvantages: React.FC<IProps> = ({ advantages }) => {
  const { t } = useAppTranslation("common.advantages");
  return (
    <Group
      className="justify-start xs:justify-center rounded-2xl bg-primary-default px-3 py-3"
      gap={13}
    >
      {advantages?.map((advantage, index) => (
        <ProductDetailLine
          key={index}
          color="#00B67A"
          description={advantage}
          icon={IconBolt}
          labelClassName="font-medium"
        />
      ))}
      {!advantages?.length && (
        <>
          <ProductDetailLine
            color="#00B67A"
            description={t("level")}
            icon={IconBolt}
            labelClassName="font-medium"
          />
          <ProductDetailLine
            color="#00B67A"
            description={t("instantDelivery")}
            icon={IconBolt}
            labelClassName="font-medium"
          />
          <ProductDetailLine
            color="#00B67A"
            description={t("modifiable")}
            icon={IconBolt}
            labelClassName="font-medium"
          />
          <ProductDetailLine
            color="#00B67A"
            description={t("unranked")}
            icon={IconBolt}
            labelClassName="font-medium"
          />
          <ProductDetailLine
            color="#00B67A"
            description={t("warranty")}
            icon={IconBolt}
            labelClassName="font-medium"
          />
        </>
      )}
    </Group>
  );
};

export default SkinAdvantages;
